<section class="bd-events" aria-live="polite">
  <div class="bd-events__container">
    <div class="bd-events__table">
      <div class="bd-events__table-wrapper">
        <table mat-table [dataSource]="this.eventsDataSource">
          <ng-container [matColumnDef]="column" *ngFor="let column of eventColumns[this.activeTab]">
            <th mat-header-cell *matHeaderCellDef [style.text-align]="column === 'rootName' ? 'left' : 'inherit'">
              {{
                column === 'rootName'
                  ? 'Employer'
                  : column === 'plannedDate'
                    ? 'Planned'
                    : column === 'actualDate'
                      ? 'Actual'
                      : this.sharedService.uppercaseWords(column | unCamelCase)
              }}
            </th>

            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="column">
                <ng-container *ngSwitchCase="'actions'">
                  <div class="actions-container">
                    <button
                      class="action-button"
                      aria-label="Open event"
                      matTooltip="Open event"
                      matTooltipPosition="right"
                      (click)="openEventForm(element)"
                    >
                      <mat-icon>open_in_new</mat-icon>
                      <mat-progress-bar
                        *ngIf="loadingEvent === element.id"
                        mode="indeterminate"
                        class="button-progress-bar"
                      ></mat-progress-bar>
                    </button>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'rootName'">
                  <span
                    *ngIf="!this.sharedService.isNullOrEmpty(element.branchName)"
                    class="employer-badge branch"
                    style="margin-right: 4px"
                    matTooltipPosition="above"
                    matTooltip="Branch Employer Event"
                    >B</span
                  >
                  <a
                    [routerLink]="
                      element.branchId === null
                        ? ['/employer/overview', element.rootId]
                        : ['/employer/overview', element.rootId, element.branchId]
                    "
                  >
                    {{
                      this.sharedService.isNullOrEmpty(element[column])
                        ? '-'
                        : this.sharedService.uppercaseWords(element[column]) +
                          (!this.sharedService.isNullOrEmpty(element.branchName)
                            ? ' - ' + this.sharedService.uppercaseWords(element.branchName)
                            : '')
                    }}
                  </a>
                </ng-container>

                <ng-container *ngSwitchDefault>
                  {{
                    this.sharedService.isNullOrEmpty(element[column])
                      ? '-'
                      : this.dateColumns.includes(column)
                        ? (element[column] | date: this.dateFormat)
                        : this.sharedService.uppercaseWords(element[column])
                  }}<span *ngIf="column === 'plannedDate' && element.startTime !== null">{{ addTime(element) }}</span>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="eventColumns[this.activeTab]; sticky: true"
            [class.bd-events__row--hidden]="loading"
          ></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: eventColumns[this.activeTab]"
            [class.bd-events__row--hidden]="loading"
          ></tr>
          <tr class="mat-row" *matNoDataRow [class.bd-events__row--hidden]="loading">
            <ng-container>
              <td class="mat-cell bd-events__no-data" [attr.colspan]="eventColumns[this.activeTab]?.length || 1">
                {{ this.eventError ? this.dataError : 'No Events' }}
              </td>
            </ng-container>
          </tr>
        </table>
        <div class="bd-events__loading-overlay" *ngIf="loading">
          <div class="bd-events__loading-content">
            <mat-spinner diameter="40"></mat-spinner>
            <span class="bd-events__loading-text">Loading Business Development Events...</span>
          </div>
        </div>
      </div>
      <mat-paginator
        class="bd-events__paginator"
        [pageSize]="this.pageSize"
        [length]="this.totalEvents"
        showFirstLastButtons
        (page)="handlePageEvent($event)"
        aria-label="Select page"
        [disabled]="this.loading"
      >
      </mat-paginator>
    </div>
  </div>
</section>
